import React from 'react';
import { Box, Container, Typography, Paper, TextField, FormControlLabel, Checkbox, CircularProgress } from '@mui/material';
import { Button } from './ui';

const ContactFormScreen = ({ formData, handleFormChange, handleSubmitForm, handleBack, isSubmitting = false }) => (
  <Box sx={{ minHeight: '100vh', py: 5, display: 'flex', alignItems: 'center' }}>
    <Container maxWidth="lg">
      <Paper
        sx={{
          width: '100%',
          maxWidth: 550,
          backgroundColor: 'white',
          borderRadius: 4,
          overflow: 'hidden',
          padding: { xs: 3, md: 4 },
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          position: 'relative',
          mx: 'auto'
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 4, position: 'relative', zIndex: 1 }}>
          <Typography 
            variant="h5" 
            component="h2" 
            sx={{ 
              fontWeight: 600, 
              mb: 1, 
              color: '#121C42',
              fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' }
            }}
          >
            Para receber o resultado da simulação, preencha os campos abaixo:
          </Typography>
        </Box>
        <Box 
          sx={{ position: 'absolute', top: '10%', right: 0, width: '100%', height: '30%', background: 'linear-gradient(90deg, rgba(255,209,102,0.2) 0%, rgba(253,165,6,0.2) 100%)', borderRadius: '50% 40% 30% 50%', filter: 'blur(40px)', opacity: 0.6, zIndex: 0 }} 
        />
        <Box 
          component="form" 
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, position: 'relative', zIndex: 1 }}
        >
          <TextField
            fullWidth
            label="Nome"
            name="name"
            value={formData.name}
            onChange={handleFormChange}
            variant="outlined"
            size="small"
            sx={{ 
              '& .MuiOutlinedInput-root': { 
                backgroundColor: 'white', 
                borderRadius: 8,
                '& fieldset': { 
                  borderColor: 'rgba(0, 0, 0, 0.23)',
                  borderRadius: 8
                }
              }, 
              '& .MuiInputLabel-root': { 
                color: 'rgba(0, 0, 0, 0.6)',
                fontSize: { xs: '1rem', md: '1rem' }
              }, 
              '& .MuiOutlinedInput-input': { 
                color: 'rgba(0, 0, 0, 0.87)',
                fontSize: { xs: '1rem', md: '1rem' }
              } 
            }}
          />
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleFormChange}
            variant="outlined"
            size="small"
            sx={{ 
              '& .MuiOutlinedInput-root': { 
                backgroundColor: 'white', 
                borderRadius: 8,
                '& fieldset': { 
                  borderColor: 'rgba(0, 0, 0, 0.23)',
                  borderRadius: 8
                }
              }, 
              '& .MuiInputLabel-root': { 
                color: 'rgba(0, 0, 0, 0.6)',
                fontSize: { xs: '1rem', md: '1rem' }
              }, 
              '& .MuiOutlinedInput-input': { 
                color: 'rgba(0, 0, 0, 0.87)',
                fontSize: { xs: '1rem', md: '1rem' }
              } 
            }}
          />
          <TextField
            fullWidth
            label="Telefone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleFormChange}
            variant="outlined"
            size="small"
            sx={{ 
              '& .MuiOutlinedInput-root': { 
                backgroundColor: 'white', 
                borderRadius: 8,
                '& fieldset': { 
                  borderColor: 'rgba(0, 0, 0, 0.23)',
                  borderRadius: 8
                }
              }, 
              '& .MuiInputLabel-root': { 
                color: 'rgba(0, 0, 0, 0.6)',
                fontSize: { xs: '1rem', md: '1rem' }
              }, 
              '& .MuiOutlinedInput-input': { 
                color: 'rgba(0, 0, 0, 0.87)',
                fontSize: { xs: '1rem', md: '1rem' }
              } 
            }}
          />
          <FormControlLabel
            control={
              <Checkbox 
                checked={formData.consentTerms} 
                onChange={handleFormChange} 
                name="consentTerms" 
                size="small"
                sx={{ color: '#121C42', '&.Mui-checked': { color: '#121C42' } }}
              />
            }
            label={
              <Typography sx={{ 
                fontSize: { xs: '0.8rem', sm: '0.82rem', md: '1rem' }, 
                color: 'rgba(0, 0, 0, 0.7)' 
              }}>
                Ao receber o resultado você está concordando com a nossa política de privacidade.
              </Typography>
            }
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'space-between', mt: 1 }}>
            <Button
              buttonType="secondary"
              onClick={handleSubmitForm}
              disabled={!formData.name || !formData.email || !formData.consentTerms || isSubmitting}
              fullWidth
              sx={{ 
                borderRadius: 8, 
                flex: 1,
                fontSize: '1rem'
              }}
            >
              {isSubmitting ? (
                <>
                  <CircularProgress size={20} sx={{ color: 'white', mr: 1 }} />
                  Enviando...
                </>
              ) : (
                'RECEBER'
              )}
            </Button>
            <Button
              onClick={handleBack}
              sx={{ 
                borderRadius: 8, 
                flex: 1,
                fontSize: { xs: '1rem', sm: '0.9rem', md: '1rem' }
              }}
            >
              Voltar
            </Button>
          </Box>
        </Box>
        <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid rgba(0,0,0,0.1)', position: 'relative', zIndex: 1 }}>
          <Typography 
            variant="body2" 
            component="div" 
            sx={{ 
              fontSize: { xs: '0.7rem', sm: '0.72rem', md: '0.75rem' }, 
              color: 'rgba(0, 0, 0, 0.6)', 
              lineHeight: 1.4 
            }}
          >
            <strong>Disclaimer:</strong> Este cálculo é aproximado e considera uma projeção para os próximos 
            12 meses. A estimativa baseia-se nas práticas vigentes do mercado. Fatores como 
            expectativa de retorno, prazo de vencimento dos ativos, negociações entre as partes 
            e condições de mercado podem impactar os resultados. Recomendamos a consulta 
            com um de nossos Wealth Advisors.
          </Typography>
        </Box>
        <Box sx={{ mt: 2, textAlign: 'center', position: 'relative', zIndex: 1 }}>
          <Typography 
            variant="body2" 
            sx={{ 
              fontSize: { xs: '0.75rem', sm: '0.78rem', md: '0.8rem' }, 
              color: 'rgba(0, 0, 0, 0.8)', 
              lineHeight: 1.5, 
              fontWeight: 500 
            }}
          >
            No mercado tradicional: taxas entre 0,6% e 1,5% ao ano em comissões.
            <br />
            Na Monefica: fee fixo, sem comissão e sem conflito de interesse.
          </Typography>
        </Box>
      </Paper>
    </Container>
  </Box>
);

export default ContactFormScreen; 